module.exports = __webpack_public_path__ + "img/today-rank_b.13042054.png";